import { loadStripe, Stripe } from '@stripe/stripe-js';
import { apiService } from './api';
import type { StripePaymentIntentResponse, StripePaymentMethodDto } from './api';

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
    if (!stripePromise) {
        const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
        if (!key) {
            console.error('REACT_APP_STRIPE_PUBLISHABLE_KEY is not set');
            return Promise.resolve(null);
        }
        stripePromise = loadStripe(key);
    }
    return stripePromise;
}

export async function createPaymentIntent(
    amount: number,
    currency = 'usd',
    metadata?: Record<string, string>
): Promise<StripePaymentIntentResponse> {
    return apiService.createPaymentIntent(amount, currency, metadata);
}

export async function confirmPaymentIntent(paymentIntentId: string): Promise<{ status: string }> {
    return apiService.confirmPaymentIntent(paymentIntentId);
}

export async function getSavedPaymentMethods(): Promise<StripePaymentMethodDto[]> {
    return apiService.getSavedPaymentMethods();
}

export async function detachPaymentMethod(paymentMethodId: string): Promise<boolean> {
    return apiService.detachPaymentMethod(paymentMethodId);
}
